import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {useQuery} from '@apollo/client';

import {ENCODING_TARGET} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ, THIRD_PARTY_CLIENT_TYPE_TUNNELER_PUSH} from '@constants/variables';
import SegmentHeader from '@appComponents/SegmentHeader';
import {renderAddButton} from '@modules/events/utils/eventsConfigurationHelpers';
import EventsConfigurationThirdPartyTunnelerPushTable
    from '@modules/events/components/EventsConfigurationThirdPartyTunnelerPushTable';
import routes from '@constants/routes';
import {ThirdPartyTunnelerPushForm} from '@modules/events/forms/EventContent/ThirdPartyTunnelerPushForm';
import ThirdPartyTunnelerPushModel from '@modules/events/forms/EventContent/ThirdPartyTunnelerPushModel';
import {createForm} from '@utils/forms';
import {GetVtdTunnels, GetThirdPartyClientTunnelsForEventContent} from '@graphql/thirdPartyClients/query';
import {convertToInt} from '@utils/helpers';
import {showModal} from '@utils/modal';

const authorizationEncodingTargetReadObject = {
    [ENCODING_TARGET]: SECURITY_PRIVILEGES_READ,
};

const EventsConfigurationThirdPartyTunnelerPush = (props) => {
    const {eventId, eventContentId, loading, eventContent} = props;
    const {
        data: {
            vtdTunnels = [],
        } = {},
        loading: loadingVtdTunnels = true,
    } = useQuery(GetVtdTunnels, {
        fetchPolicy: 'network-only',
    });

    const {
        data: {
            eventContentThirdPartyClientTunnels = [],
        } = {},
        loading: loadingThirdPartyClientTunnels = true,
    } = useQuery(GetThirdPartyClientTunnelsForEventContent, {
        variables: {
            eventContentId: eventContentId,
        },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (
            props.match.path === routes.events.configuration.content.thirdPartyClientTunnel.add.path
            && !loading
            && !loadingVtdTunnels
            && !loadingThirdPartyClientTunnels
            && convertToInt(props.match.params.contentId) === eventContentId
        ) {

            const ThirdPartyTunnelerPushFormComponent = createForm(
                ThirdPartyTunnelerPushModel,
                ThirdPartyTunnelerPushForm,
                {
                    eventContent: eventContent,
                    encodingTargetsTunnels: eventContentThirdPartyClientTunnels,
                    vtdTunnels: vtdTunnels,
                    optionsVariables: {
                        types: [THIRD_PARTY_CLIENT_TYPE_TUNNELER_PUSH],
                    },
                }
            );

            showModal({
                isVisible: true,
                size: 'small',
                content: <ThirdPartyTunnelerPushFormComponent/>,
            });
        }
    }, [props.match.path, loading, loadingVtdTunnels, loadingThirdPartyClientTunnels, props.match.params.contentId]);

    return (
        <div>
            <SegmentHeader buttons={
                renderAddButton(
                    eventId,
                    eventContentId,
                    authorizationEncodingTargetReadObject,
                    'thirdPartyClientTunnel.add'
                )
            }>
                Third party clients (Tunneler push)
            </SegmentHeader>
            {!loadingThirdPartyClientTunnels && (
                <EventsConfigurationThirdPartyTunnelerPushTable
                    loading={loading}
                    vtdTunnels={vtdTunnels}
                    encodingTargetsTunnels={eventContentThirdPartyClientTunnels}
                />
            )}
        </div>
    );
};

EventsConfigurationThirdPartyTunnelerPush.propTypes = {
    match: PropTypes.object,
    eventContentId: PropTypes.number.isRequired,
    eventId: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    eventContent: PropTypes.object,
};

export default withRouter(EventsConfigurationThirdPartyTunnelerPush);
